module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_nihonteien-b3f9b7ac3dbff60c14b9379611607c41.jpg";